module.exports = __webpack_public_path__ + "static/media/facebook-brands.62d8b6ef.svg";